window.VH = window.VH === undefined ? {} : window.VH;
VH.SyncPanel = {
    container : null,
    checkUrl : null,

    run : function() {
        let _t = VH.SyncPanel;

        $.get(_t.checkUrl, {}, function(data) {
            _t.container.html(data);
        });

        setTimeout(function () {
            _t.run();
        }, 10000);
    },

    init: function() {
        let _t = VH.SyncPanel;
        _t.container = $('#syncStates');
        _t.checkUrl = _t.container.data('check-url');
        _t.run();
    }
};